var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconeOlhoLigadoCinza(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline",
    transform: "translate(-1 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_125",
    "data-name": "Grupo 125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2553",
    "data-name": "Caminho 2553",
    d: "M12,6a9.77,9.77,0,0,1,8.82,5.5,9.822,9.822,0,0,1-17.64,0A9.77,9.77,0,0,1,12,6m0-2A11.827,11.827,0,0,0,1,11.5a11.817,11.817,0,0,0,22,0A11.827,11.827,0,0,0,12,4Z",
    fill: "#243B53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2554",
    "data-name": "Caminho 2554",
    d: "M12,9a2.5,2.5,0,1,1-2.5,2.5A2.5,2.5,0,0,1,12,9m0-2a4.5,4.5,0,1,0,4.5,4.5A4.507,4.507,0,0,0,12,7Z",
    fill: "#243B53"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeOlhoLigadoCinza);
export default __webpack_public_path__ + "static/media/icone-olho-ligado-cinza.d79c705366ca7045e0119365ca2786c8.svg";
export { ForwardRef as ReactComponent };